import React, { useState } from "react";
import axios from "axios";
import { Mail, CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterForm = () => {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle"); // idle | loading | success | error
    const [message, setMessage] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setStatus("loading");
        setMessage("");
        try {
            const { data } = await axios.post(`${API}/newsletter`, { email });
            setStatus("success");
            setMessage(data?.message || "Inscription confirmée");
            setEmail("");
        } catch (err) {
            setStatus("error");
            const detail = err?.response?.data?.detail;
            const text =
                typeof detail === "string"
                    ? detail
                    : "Email invalide. Veuillez réessayer.";
            setMessage(text);
        }
    };

    return (
        <form
            onSubmit={onSubmit}
            className="space-y-3"
            data-testid="newsletter-form"
        >
            <div className="flex items-center gap-2 text-white">
                <Mail size={16} className="text-[#00C853]" />
                <span className="font-heading font-bold text-sm uppercase tracking-wider">
                    Newsletter
                </span>
            </div>
            <p className="text-xs text-gray-400 leading-relaxed">
                Recevez chaque semaine les dernières infos et nos pronostics
                foot. Aucun spam, désabonnement en 1 clic.
            </p>
            <div className="flex flex-col sm:flex-row gap-2">
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre@email.com"
                    aria-label="Adresse email"
                    data-testid="newsletter-input"
                    disabled={status === "loading"}
                    className="flex-1 bg-[#0D1B2A] border border-[#2A4A6B] rounded-lg px-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#00C853] focus:border-transparent disabled:opacity-60"
                />
                <button
                    type="submit"
                    disabled={status === "loading"}
                    data-testid="newsletter-submit"
                    className="btn-green !py-2 !px-4 text-xs whitespace-nowrap disabled:opacity-70"
                >
                    {status === "loading" ? (
                        <Loader2 size={14} className="animate-spin" />
                    ) : (
                        "S'inscrire"
                    )}
                </button>
            </div>
            {status === "success" && (
                <div
                    className="flex items-center gap-2 text-xs text-[#00C853]"
                    data-testid="newsletter-success"
                >
                    <CheckCircle2 size={14} />
                    {message}
                </div>
            )}
            {status === "error" && (
                <div
                    className="flex items-center gap-2 text-xs text-[#FFB300]"
                    data-testid="newsletter-error"
                >
                    <AlertCircle size={14} />
                    {message}
                </div>
            )}
        </form>
    );
};

export default NewsletterForm;
